import React from "react";

const BackLinkContext = React.createContext();

export default BackLinkContext;
